import { createFileRoute } from "@tanstack/react-router";
import { WaitingOnPage } from "../features/topo/WaitingOnPage";

export const Route = createFileRoute("/w/$ws/waiting")({ component: WaitingOnPage });
